import { createModalHook } from '../../hooks'

export const useGetHelpModal = createModalHook()

export const useOrderRefundModal = createModalHook()
